import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button, Form, Row, Col, Spinner, Alert } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faMessage,
  faCircleCheck,
  faTriangleExclamation,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

export default function Info({ closeModal }) {
  const navigate = useNavigate();

  const [showSuccess, setShowSuccess] = useState(false);

  const [validated, setValidated] = useState(false);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const [loading, setLoading] = useState(false);
  const [serverError, setServerError] = useState("");

  const emailRegex = useMemo(
    () =>
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    []
  );

  const emailIsValid = emailRegex.test(email);

  const handleCloseAll = () => {
    setShowSuccess(false);
  };

  const handleBackHome = () => navigate("/");
  const handleClose = () => {
    if (closeModal) closeModal();
  };

  async function sendEmail(e) {
    e.preventDefault();
    e.stopPropagation();

    setServerError("");
    setValidated(true);

    // validation côté UI
    if (!email || !message || !emailIsValid) return;

    try {
      setLoading(true);

      const token = "1654551514hhgfhfb45665454";
      const url = `${process.env.REACT_APP_BAC_URL}/mail/contact`;

      const payload = { email, message };

      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: "bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.status === 200) {
        setShowSuccess(true);
        setValidated(false);
        setEmail("");
        setMessage("");
      } else {
        setServerError(
          "Une erreur est survenue lors de l’envoi. Veuillez réessayer."
        );
      }
    } catch (err) {
      setServerError(
        "Impossible de contacter le serveur. Vérifiez votre connexion puis réessayez."
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {/* MODALE FORMULAIRE */}
      <Modal
        show={!showSuccess}
        onHide={handleClose}
        centered
        size="lg"
        dialogClassName="vtc-modal"
        contentClassName="vtc-modal-content"
      >
        <Modal.Header className="vtc-modal-header">
          <div className="vtc-modal-titlewrap">
            <div className="vtc-modal-kicker">Contact</div>
            <Modal.Title className="vtc-modal-title">
              Une question ? Un devis ?
            </Modal.Title>
          </div>

          <button
            type="button"
            className="vtc-modal-close"
            aria-label="Fermer"
            onClick={handleClose}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </Modal.Header>

        <Modal.Body className="vtc-modal-body">
          <p className="vtc-modal-lead">
            Laissez-nous votre message. Réponse rapide.
          </p>

          {serverError && (
            <Alert variant="danger" className="vtc-alert">
              <FontAwesomeIcon icon={faTriangleExclamation} className="me-2" />
              {serverError}
            </Alert>
          )}

          <Form noValidate validated={validated} onSubmit={sendEmail}>
            <Row className="g-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="vtc-label">
                    <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                    Email *
                  </Form.Label>
                  <Form.Control
                    className="vtc-input"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="exemple@gmail.com"
                    required
                    isInvalid={validated && (!email || !emailIsValid)}
                  />
                  <Form.Control.Feedback type="invalid">
                    Merci de saisir une adresse email valide.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={6}>
                <div className="vtc-info-card">
                  <div className="vtc-info-text">
                    Contact direct :{" "}
                    <a className="vtc-link" href="tel:0626652539">
                      06 26 65 25 39
                    </a>
                  </div>
                  <div className="vtc-info-sub">
                    Réponse rapide — transferts aéroport, Monaco, ski, business.
                  </div>
                </div>
              </Col>

              <Col md={12}>
                <Form.Group>
                  <Form.Label className="vtc-label">
                    <FontAwesomeIcon icon={faMessage} className="me-2" />
                    Message *
                  </Form.Label>
                  <Form.Control
                    className="vtc-input"
                    as="textarea"
                    rows={5}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Décrivez votre besoin : date, heure, départ/arrivée, nombre de passagers, bagages, etc."
                    required
                    isInvalid={validated && !message}
                  />
                  <Form.Control.Feedback type="invalid">
                    Merci de saisir votre message.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <div className="vtc-modal-actions">
              <Button
                variant="outline-secondary"
                className="vtc-btn-outline"
                onClick={handleClose}
              >
                Retour
              </Button>

              <Button
                type="submit"
                className="btn-primary-gold vtc-btn-gold"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Envoi…
                  </>
                ) : (
                  "Envoyer"
                )}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* MODALE SUCCESS */}
      <Modal
        show={showSuccess}
        onHide={handleClose}
        centered
        dialogClassName="vtc-modal"
        contentClassName="vtc-modal-content"
      >
        <Modal.Header className="vtc-modal-header">
          <div className="vtc-modal-titlewrap">
            <div className="vtc-modal-kicker">Confirmation</div>
            <Modal.Title className="vtc-modal-title">
              Message envoyé
            </Modal.Title>
          </div>

          <button
            type="button"
            className="vtc-modal-close"
            aria-label="Fermer"
            onClick={handleClose}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </Modal.Header>

        <Modal.Body className="vtc-modal-body">
          <div className="vtc-success">
            <div className="vtc-success-icon">
              <FontAwesomeIcon icon={faCircleCheck} />
            </div>
            <div className="vtc-success-text">
              Merci. Nous revenons vers vous au plus vite.
            </div>
          </div>

          <div className="vtc-modal-actions">
            <Button
              className="btn-primary-gold vtc-btn-gold"
              onClick={handleClose}
            >
              Revenir à l’accueil
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
